export const UserRoles = [
    { value: 'ROLE_ADMIN', label: 'Administrateur' },
    { value: 'ROLE_USER', label: 'Chauffeur' },
]

export default UserRoles
